import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import configService from '../../services/configService';

const DropDownShow = (props) => {
    const [allShows, setAllShows] = useState([]);

    useEffect(() => {
        configService.shows(props.withAwardsDBConnection)
            .then(data => setAllShows(data));
    }, []);
    
    return (
        <Input type="select" title="Select Show" name="show" value={props.show} onChange={event => props.onShowChanged(event.target.value)}>
            <option value="">Select a show from the list</option>
            {
                (allShows || props.shows || []).map((show) => <option key={show.toString().toLowerCase()} value={show}>{show}</option>)
            }
        </Input>
    );
}

export default DropDownShow;